import { connect } from 'react-redux';
import { requestProfile,
  setPassword,
  editProfile,
  gotoProfile,
  gotoProfileEdit,
  gotoProfilePassword,
  editProfileImage
} from '../modules/profile';

import ProfileLayout from '../components/ProfileLayout';

const mapDispatchToProps = {
  requestProfile,
  setPassword,
  editProfile,
  gotoProfile,
  gotoProfileEdit,
  gotoProfilePassword,
  editProfileImage
};

const mapStateToProps = (state, ownProps) => ({
  isFetching: state.profile.isFetching,
  needFetch: state.profile.needFetch,
  profile: state.profile.selectedProfile,
  action: ownProps.params.key ? ownProps.params.key : 'profile',
  perms: state.auth.perms
});

export default connect(mapStateToProps, mapDispatchToProps)(ProfileLayout);



// WEBPACK FOOTER //
// src/routes/profile/containers/ProfileContainer.js